import { render } from "./trashcan-icon.vue?vue&type=template&id=2cee0022"
const script = {}
script.render = render

export default script